import React, { useEffect, useRef } from 'react';
import { companyInfo } from '@/mockData';
const PrivacyPolicy = () => {
  const canvasRef = useRef(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let animationId;
    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resize();
    window.addEventListener('resize', resize);
    const STAR_COUNT = 180;
    const stars = Array.from({ length: STAR_COUNT }, () => ({
      x: Math.random() * window.innerWidth,
      y: Math.random() * window.innerHeight,
      z: Math.random() * 1.5 + 0.2,
      radius: Math.random() * 1.2 + 0.3,
      opacity: Math.random() * 0.5 + 0.2,
      twinkleSpeed: Math.random() * 0.02 + 0.005,
      twinkleOffset: Math.random() * Math.PI * 2,
      vx: (Math.random() - 0.5) * 0.3,
      vy: (Math.random() - 0.5) * 0.3,
    }));
    let tick = 0;
    const draw = () => {
      tick++;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      stars.forEach(star => {
        star.x += star.vx * star.z;
        star.y += star.vy * star.z;
        if (star.y > canvas.height + 2) star.y = -2;
        if (star.y < -2) star.y = canvas.height + 2;
        if (star.x < -2) star.x = canvas.width + 2;
        if (star.x > canvas.width + 2) star.x = -2;
        const twinkle = Math.sin(tick * star.twinkleSpeed + star.twinkleOffset) * 0.3 + 0.7;
        const alpha = star.opacity * twinkle;
        const grd = ctx.createRadialGradient(star.x, star.y, 0, star.x, star.y, star.radius * 3 * star.z);
        grd.addColorStop(0, `rgba(220, 230, 255, ${alpha})`);
        grd.addColorStop(0.4, `rgba(180, 200, 255, ${alpha * 0.5})`);
        grd.addColorStop(1, `rgba(100, 130, 200, 0)`);
        ctx.beginPath();
        ctx.arc(star.x, star.y, star.radius * star.z * 3, 0, Math.PI * 2);
        ctx.fillStyle = grd;
        ctx.fill();
        ctx.beginPath();
        ctx.arc(star.x, star.y, star.radius * star.z * 0.7, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(230, 240, 255, ${alpha * 0.9})`;
        ctx.fill();
      });
      animationId = requestAnimationFrame(draw);
    };
    draw();
    return () => {
      cancelAnimationFrame(animationId);
      window.removeEventListener('resize', resize);
    };
  }, []);
  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0a0a0f 0%, #0d1117 40%, #0a0f1a 70%, #050508 100%)',
      fontFamily: "'Georgia', serif",
      color: '#c8d0e0',
      position: 'relative',
      overflow: 'hidden',
    }}>
        <style>{'footer { background: linear-gradient(135deg, #0d1117 40%, #0a0f1a 70%, #050508 100%) !important;} '}</style>
      <canvas
        ref={canvasRef}
        style={{
          position: 'fixed',
          top: 0, left: 0,
          width: '100%', height: '100%',
          pointerEvents: 'none',
          zIndex: 0,
        }}
      />
      <div style={{
        position: 'fixed', top: '-20%', right: '-10%',
        width: '600px', height: '600px',
        background: 'radial-gradient(circle, rgba(100,130,200,0.06) 0%, transparent 70%)',
        pointerEvents: 'none', zIndex: 0,
      }} />
      <div style={{
        position: 'fixed', bottom: '-20%', left: '-10%',
        width: '500px', height: '500px',
        background: 'radial-gradient(circle, rgba(80,110,180,0.05) 0%, transparent 70%)',
        pointerEvents: 'none', zIndex: 0,
      }} />
      <div style={{ position: 'relative', zIndex: 1, maxWidth: '800px', margin: '0 auto', padding: '80px 24px' }}>
        <div style={{ marginBottom: '60px' }}>
          <p style={{
            fontSize: '11px', letterSpacing: '4px', textTransform: 'uppercase',
            color: '#6a7fa8', marginBottom: '16px', fontFamily: "'Georgia', serif",
          }}>{companyInfo.name}</p>
          <h1 style={{
            fontSize: '48px', fontWeight: '300', letterSpacing: '-1px',
            background: 'linear-gradient(135deg, #e8edf5 0%, #a0b0cc 40%, #c8d4e8 70%, #7a90b0 100%)',
            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
            marginBottom: '16px', lineHeight: '1.1',
          }}>Privacy Policy</h1>
          <div style={{
            width: '60px', height: '1px',
            background: 'linear-gradient(90deg, #4a6080, transparent)',
            marginBottom: '16px',
          }} />
          <p style={{ fontSize: '13px', color: '#4a5a70', letterSpacing: '1px' }}>Last updated: March 2026</p>
        </div>
        <p style={{
          fontSize: '15px', lineHeight: '1.9', color: '#8a9ab8',
          marginBottom: '48px',
          padding: '24px 28px',
          border: '1px solid rgba(100,130,180,0.12)',
          borderLeft: '2px solid rgba(100,130,180,0.3)',
          background: 'rgba(255,255,255,0.02)',
          borderRadius: '0 8px 8px 0',
        }}>
          By using this site, you are accepting the practices described in this privacy policy. These practices may be changed, but any changes will be posted and will only apply to activities and information on a going forward, not retroactive basis. You are encouraged to review the privacy policy whenever you visit the site.
        </p>
        {[
          { title: 'Note', content: 'The privacy practices set forth in this privacy policy are for this website only. If you link to other websites, please review the privacy policies posted at those sites.' },
          { title: 'Information We Collect', content: 'Vetam Remedies Private Limited collects personally identifiable information, like names, email addresses, and phone numbers, only when voluntarily submitted through contact or partner application forms. This information is used solely to respond to inquiries and is never sold or shared with third parties.' },
          { title: 'Cookie & Tracking Technology', content: 'This site may use cookie and tracking technology depending on the features offered. Cookies are useful for gathering information such as browser type and operating system, tracking the number of visitors, and understanding how visitors use the site.' },
          { title: 'Distribution of Information', content: 'We do not share your personal information with third parties except as necessary to respond to your inquiry or as required by law. We do not sell, trade, or rent your personal information to others.' },
          { title: 'Commitment to Data Security', content: 'Your personally identifiable information is kept secure. Only authorized employees and agents who have agreed to keep information secure and confidential have access to this information.' },
        ].map((section, i) => (
          <div key={i} style={{ marginBottom: '40px' }}>
            <div style={{ display: 'flex', alignItems: 'baseline', flexWrap: 'nowrap', gap: '12px', marginBottom: '12px' }}>
              <span style={{ fontSize: '10px', color: '#3a5070', fontFamily: 'monospace', letterSpacing: '1px' }}>0{i + 1}</span>
              <h2 style={{
                fontSize: '13px', letterSpacing: '2px', textTransform: 'uppercase',
                background: 'linear-gradient(90deg, #b0c0d8, #7a90b0)',
                WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
                fontWeight: '600',
              }}>{section.title}</h2>
              <div style={{ flex: 1, height: '1px', background: 'rgba(100,130,180,0.1)' }} />
            </div>
            <p style={{ fontSize: '15px', lineHeight: '1.9', color: '#7a8aa0', paddingLeft: '15px' }}>{section.content}</p>
          </div>
        ))}
        <div style={{
          marginTop: '60px', padding: '32px',
          background: 'rgba(100,130,180,0.04)',
          border: '1px solid rgba(100,130,180,0.1)',
          borderRadius: '12px',
        }}>
          <h2 style={{
            fontSize: '13px', letterSpacing: '2px', textTransform: 'uppercase',
            background: 'linear-gradient(90deg, #b0c0d8, #7a90b0)',
            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
            fontWeight: '600', marginBottom: '20px',
          }}>Contact Us</h2>
          <div style={{ fontSize: '14px', lineHeight: '2', color: '#6a7a90' }}>
            <p style={{ color: '#8a9ab8', fontWeight: '500' }}>{companyInfo.name}</p>
            <p>{companyInfo.corporateOffice.address}</p>
            <p>Phone: <a href={`tel:${companyInfo.corporateOffice.phone}`} style={{ color: '#8a9ab8', textDecoration: 'none' }}>{companyInfo.corporateOffice.phone}</a></p>
            <p>Email: <a href={`mailto:${companyInfo.corporateOffice.email}`} style={{ color: '#8a9ab8', textDecoration: 'none' }}>{companyInfo.corporateOffice.email}</a></p>
          </div>
        </div>
        <div style={{
          marginTop: '60px', paddingTop: '24px',
          borderTop: '1px solid rgba(100,130,180,0.08)',
          textAlign: 'center',
          fontSize: '11px', letterSpacing: '2px', color: '#2a3a50',
          textTransform: 'uppercase',
        }}>
          © {new Date().getFullYear()} {companyInfo.name}
        </div>
      </div>
    </div>
  );
};
export default PrivacyPolicy;